import AxiosPermisos from "./../../axiosPermisos";
import { path } from "./path";

async function getDiagnostics(id) {
  return await AxiosPermisos.get(`${path.getDiagnostics}/${id}`, true, "v2");
}

async function getCalifications(id) {
  return await AxiosPermisos.get(
    `${path.getCalifications}/${id}/list`,
    true,
    "v2"
  );
}

async function getGroupDiagnostics(data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.getGroupDiagnostics}`,
    true,
    "v2",
    data,
    signal
  );
}

async function getDiagnosticsById(id, data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.getDiagnosticsById}/${id}`,
    true,
    "v2",
    data,
    signal
  );
}

async function getInfoSelect(code) {
  return await AxiosPermisos.get(`${path.getInfoSelect}`, true, "v2", { code });
}

async function saveDiagnostic(data) {
  return await AxiosPermisos.postSendFile(
    `${path.saveDiagnostic}`,
    true,
    data,
    "v2"
  );
}

async function editDiagnostic(data, id) {
  return await AxiosPermisos.postSendFile(
    `${path.editDiagnostic}/${id}`,
    true,
    data,
    "v2"
  );
}

async function detailDiagnostic(id) {
  return await AxiosPermisos.get(
    `${path.detailDiagnostic}/${id}/show`,
    true,
    "v2"
  );
}

async function deleteDiagnostic(id) {
  return await AxiosPermisos.delete(
    `${path.detailDiagnostic}/${id}`,
    true,
    "v2"
  );
}

async function saveQualification(data) {
  return await AxiosPermisos.postSendFile(
    `${path.saveQualification}`,
    true,
    data,
    "v2"
  );
}

async function editQualification(data, id) {
  return await AxiosPermisos.postSendFile(
    `${path.editQualification}/${id}`,
    true,
    data,
    "v2"
  );
}

async function detailQualification(id) {
  return await AxiosPermisos.get(
    `${path.detailQualification}/${id}`,
    true,
    "v2"
  );
}

async function deleteQualification(id) {
  return await AxiosPermisos.delete(
    `${path.detailQualification}/${id}`,
    true,
    "v2"
  );
}

async function getPCLs(id) {
  return await AxiosPermisos.get(`${path.getPCLs}/${id}`, true, "v2");
}

async function savePCL(data) {
  return await AxiosPermisos.postSendFile(`${path.savePCL}`, true, data, "v2");
}

async function editPCL(data, id) {
  return await AxiosPermisos.postSendFile(
    `${path.editPCL}/${id}`,
    true,
    data,
    "v2"
  );
}

async function detailPCL(id) {
  return await AxiosPermisos.get(`${path.detailPCL}/${id}/detail`, true, "v2");
}

async function deletePCL(id) {
  return await AxiosPermisos.delete(`${path.detailPCL}/${id}`, true, "v2");
}

async function getStatistics(data = {}) {
  return await AxiosPermisos.get(`${path.statistics}`, true, "v2", data);
}

async function getLocations(data) {
  return await AxiosPermisos.get(`${path.locations}`, true, "v2", data);
}

async function getAreas(data) {
  return await AxiosPermisos.get(`${path.areas}`, true, "v2", data);
}

async function getEmployees(data = {}, signal) {
  return await AxiosPermisos.get(`${path.employees}`, true, "v2", data, signal);
}
function debounce(func, wait) {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    const context = this;
    timer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}

export {
  getDiagnostics,
  getGroupDiagnostics,
  getDiagnosticsById,
  getInfoSelect,
  getCalifications,
  saveDiagnostic,
  saveQualification,
  editDiagnostic,
  editQualification,
  detailDiagnostic,
  deleteDiagnostic,
  detailQualification,
  deleteQualification,
  getPCLs,
  savePCL,
  editPCL,
  detailPCL,
  deletePCL,
  debounce,
  getStatistics,
  getLocations,
  getAreas,
  getEmployees,
};
